import React, {Component} from 'react';
import couterpart from 'counterpart';

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderAdditions from './WorkOrderAdditions';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderButtons from './WorkOrderButtons';
import ItemDetailsViewById from './ItemDetailsViewById';
import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';

import '../css/style.css';
import { ICON_BACK } from '../icon';

class WorkOrderWork extends Component {
    constructor() {
        super();
        this.state = {
            allStatus: [],
            workOrder: {},
            workOrderId: 0,
            updated: false,
            options: ""
        };
    };

    componentDidMount () {
        const { id } = this.props.match.params;
        WorkOrderDataService.retrieveById(`${id}`).then(data => {
            this.setState({ 
                workOrderId: id,
                workOrder:  data,
                updated: true
            });
        });
        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ allStatus:  data}) 
        });        
    }

    getStatusDescription(status){
        if (this.state.allStatus === undefined || this.state.allStatus === null){
            return status;
        }        
        let istatus = parseInt(status);
        let statusInfo = this.state.allStatus.find(x =>{
            return x.status === istatus;
        });
        if (statusInfo !== undefined){
            return statusInfo.statusDescVn;
        }   
        return status;     
    } 

    handleUpdate (){
        this.setState({
            updated: true
        });  
    }

    renderWorkerByRole(){
        if (!AuthenticationService.isAdmin()){
            return (<label>{this.state.workOrder.workerFullName}</label>);
        }

        if((this.state.selectOptions ===undefined) || (this.state.selectOptions === null)){
            return (<></>);
        }
        return(
        <select defaultValue={this.state.workOrder.worker} onChange={this.handleSelectChange.bind(this)}>
        {this.state.selectOptions !== undefined && this.state.selectOptions.map(option =>this.renderOption(option))}
        </select>
        );
    }

    renderForAdminOrService(){
        if (AuthenticationService.isWorker()){
            return(<></>);
        }

        const work_order_additions = couterpart.translate('work_order_additions');
        return(
            <td valign="top">
            <table width="100%" border="0">
            <tbody>
                <tr>
                    <td></td>
                    <td colSpan = "2">
                    <WorkOrderAdditions caption={work_order_additions} workOrderId={this.state.workOrderId}/>
                    </td>
                </tr>
                <tr>
                <td></td>
                    <td colSpan = "2">
                    <ItemDetailsViewById itemSku={this.state.workOrder.sku}/>
                    </td>
                </tr>                             
            </tbody>
            </table>
            </td> 
        );
    }

    backToList(){
        this.props.history.push("/workOrders");
    }
      
    render() {
        if (this.state.workOrderId === 0){
            return (<></>);
        }        
        const work_order_worker = couterpart.translate('work_order_worker');
        const work_order_start_date = couterpart.translate('work_order_start_date');
        const work_order_end_date = couterpart.translate('work_order_end_date');
        const work_order_code = couterpart.translate('work_order_code');
        const work_order_code_p = couterpart.translate('shop_pcode');
        const work_order_color = couterpart.translate('work_order_color');
        const work_order_type = couterpart.translate('work_order_type');
        const work_order_quantity_s = couterpart.translate('work_order_quantity_s');
        const work_order_size = couterpart.translate('work_order_size');
        const work_order_customer_s = couterpart.translate('work_order_customer_s');
        const work_order_urgent = couterpart.translate('work_order_urgent');
        const work_order_personalization = couterpart.translate('work_order_personalization');
        const button_back = couterpart.translate('button_back');
        const work_order_status = couterpart.translate('work_order_status');

        return (
            <div>
            <MenuComponent2/>
            <div style={{padding:"5px"}}>
                <button className="myButton" onClick={this.backToList.bind(this)}>
                        <img alt={button_back} src={ICON_BACK}/>&nbsp;{button_back}&nbsp;&nbsp;&nbsp;&nbsp;</button>
            </div>
            <div className="row">
                <div className="col-8">
                    <div className="row">
                        <div className="col-3 border-top border-left border-light-gray">
                            <div className="row">
                                <img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode}/>
                            </div>
                            <div className="row">{this.state.workOrder.workOrderNo}</div>
                        </div>
                        <div className="col-7 border-top border-left border-light-gray">
                            <div className="row border-bottom border-light-gray">
                                <div className="col"><b>{work_order_worker}</b></div>
                                <div className="col border-left border-right border-light-gray">{this.renderWorkerByRole()}</div>
                            </div>
                            <div className="row border-bottom border-light-gray">
                                <div className="col"><b>{work_order_start_date}</b></div>
                                <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatDisplayDateMMddyyyy(this.state.workOrder.startDate)}</div>
                            </div>
                            <div className="row border-bottom border-light-gray">
                                <div className="col"><b>{work_order_end_date}</b></div>
                                <div className="col border-left border-right border-light-gray">{this.state.workOrder.endDate}</div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-1 border-top border-left border-light-gray"><b>{work_order_code}</b></div>
                        <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.sku}</div>
                        <div className="col-1 border-top border-left border-light-gray"><b>{work_order_code_p}</b></div>
                        <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.fullPCode}</div>
                        <div className="col-1 border-top border-left border-light-gray"><b>{work_order_color}</b></div>
                        <div className="col-2 border-top border-left border-right border-light-gray">{this.state.workOrder.colorMaterial}</div>
                    </div>
                    <div className="row">
                        <div className="col-1 border-top border-left border-light-gray"><b>{work_order_type}</b></div>
                        <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.shapeDesign}</div>
                        <div className="col-1 border-top border-left border-light-gray"><b>{work_order_quantity_s}</b></div>
                        <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.qty}</div>
                        <div className="col-1 border-top border-left border-light-gray"><b>{work_order_size}</b></div>
                        <div className="col-3 border-top border-left border-right border-light-gray">{this.state.workOrder.lengthSize}</div>
                    </div>
                    <div className="row">
                        <div className="col-2 border-top border-left border-light-gray"><b>{work_order_customer_s}</b></div>
                        <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.customer}</div>
                        <div className="col-2 border-top border-left border-light-gray"><b>{work_order_urgent}</b></div>
                        <div className="col-3 border-top border-left border-right border-light-gray">{this.state.workOrder.carrierServiceRequested}</div>
                    </div>
                    <div className="row">
                        <div className="col-2 border-top border-left border-light-gray"><b>{work_order_personalization}</b></div>
                        <div className="col-8 border-top border-left border-right border-light-gray"><pre>{this.state.workOrder.personalization}</pre></div>
                    </div>
                    <div className="row">
                        <div className="col-10 border-top border-left border-right border-light-gray">
                            <WorkOrderImages 
                                workOrderId={this.state.workOrderId} 
                                isUpdated={this.state.updated}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-10 border-top border-left border-right border-light-gray">
                            <span><b>{work_order_status}</b>: { this.getStatusDescription(this.state.workOrder.status) }</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-10 border border-light-gray">
                            <br/>
                            <WorkOrderButtons workOrderId={this.state.workOrderId}
                                    orderId={this.state.workOrder.orderInfoId} 
                                    workCardId={this.state.workOrder.workCardId}
                                    currentStatus={this.state.workOrder.status}/>
                        </div>
                    </div>                                                                                                                        
                </div>
            </div>
        </div>
        );
    }
}
export default WorkOrderWork;